<template>
  <div id="group-hotels-create">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            v-if="routeType"
            :disabled="disableSaveButton"
            tooltipText="Para salvar, preencha os campos obrigatórios sinalizados com *"
            class="page-actions--button"
            @click="create()"
          >
            Salvar
          </Button>

          <Button
            v-else
            :disabled="disableSaveButton"
            tooltipText="Para salvar, preencha os campos obrigatórios sinalizados com *"
            class="page-actions--button"
            @click="edit()"
          >
            Salvar
          </Button>

          <Button
            layout="outline"
            class="page-actions--button"
            @click="$router.push({ name: 'AgrupadorHoteisListagem' })"
          >
            Voltar sem salvar
          </Button>

          <Button
            v-if="!routeType"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal($route.params.id)"
          >
            Excluir
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>

          <Paragraph class="page-actions--tip-text">
            Crie Agrupadores de Hotéis para simplificar e otimizar a gestão de
            Tarifas Master e Produtos Master. Agrupe hotéis por região, tipo ou
            estratégia de campanha, facilitando a aplicação de ações em massa,
            análise estratégica de resultados e filtragem nas listagens de
            reservas e relatórios dos hotéis.<br /><br />Exemplo: Com um
            Agrupador de Hotéis, você pode aplicar uma Tarifa Master ou Produto
            Master a dezenas de hotéis instantaneamente, sem o processo
            repetitivo de selecionar manualmente cada hotel.
          </Paragraph>
        </SidebarBlock>
      </template>

      <!-- FORMULÁRIO -->
      <template #content>
        <span class="form">
          <FormInput
            v-model="nome"
            :error="error.nome"
            :showErrorFeedbackMessage="true"
            :maxlength="150"
            label="Nome do agrupador"
            placeholder="Insira o nome do grupo"
            class="text-input--email"
            showCounter
            required
          />
        </span>

        <span class="form">
          <PmwSelectionBox
            v-model="selectedItems"
            :list="options"
            placeholder="Busque pelo nome do hotel"
            selectedPlaceholder="Busque pelo nome do hotel selecionado"
            titleFirstBox="Adicionar hotéis"
            titleSecondBox="Hotéis selecionados"
          >
          </PmwSelectionBox>

          <hr class="horizontal-line" />
        </span>

        <!-- FOOTER -->
        <span class="bottom-buttons">
          <Button
            layout="outline"
            class="bottom-buttons--return"
            @click="$router.push({ name: 'AgrupadorHoteisListagem' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="routeType"
            :disabled="disableSaveButton"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            :popperStrategy="'auto'"
            class="bottom-buttons--save"
            @click="create()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton"
            class="bottom-buttons--save"
            @click="edit()"
          >
            Salvar
          </Button>
        </span>
      </template>
    </SidebarLayout3>

    <!-- MODAL DELEÇÃO -->
    <AlertModal
      v-model="showDeleteModal"
      :buttonClose="true"
      title="Excluir agrupador de hotéis"
      @alert-modal-cancel="cancelDisable()"
      @alert-modal-confirm="disable()"
    >
      <template #text>
        Ao excluir esse agrupador, não será mais possível visualizar as
        informações contidas nele de forma compilada em relatórios. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>

    <!-- MODAL - JÁ EXISTE UM AGRUPADOR COM ESSE MESMO NOME -->
    <AlertModal
      v-model="showDuplicateAlert"
      :buttonClose="true"
      title="Nome de grupo duplicado"
      icon="pmw-alert"
      confirmButtonText="Alterar nome"
      cancelButtonText=""
      class="alert-modal__duplicate-alert"
    >
      <template #text>
        Já existe um grupo de hotéis com o nome <strong>{{ nome }}</strong
        >. Por favor, insira um novo nome para continuar.
      </template>
    </AlertModal>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwSelectionBox from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'

/** Imports do projeto */
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'hotelBundlerCreate',

  components: {
    Button,
    FormInput,
    Heading,
    SidebarLayout3,
    AlertModal,
    PmwSelectionBox,
    SidebarBlock,
    Paragraph
  },

  data() {
    return {
      options: [] /** Opções de hotéis */,
      selectedItems: [] /** Array de itens selecionados */,
      nome: '' /** Nome do grupo */,
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Agrupador de hotéis',
          url: '/Admin/v2/agrupador-hoteis'
        },
        {
          label: null
        }
      ],

      /** Guarda tipo de página (Edição/Criação)  */
      routeType: '',

      /** Título da página  */
      pageTitle: null,

      /** Exibição da modal de deleção */
      showDeleteModal: false,

      /** Exibição da modal de agrupador duplicado */
      showDuplicateAlert: false,

      /** Guarda Id do agrupador */
      grouperId: null,

      /** Controle de erro */
      error: {
        nome: false
      },

      loading: false
    }
  },

  computed: {
    disableSaveButton() {
      if (
        this.nome !== '' &&
        this.selectedItems.length !== 0 &&
        !this.loading
      ) {
        return false
      }

      return true
    }
  },

  watch: {
    /** Controle de erro de nome */
    nome: {
      handler: function() {
        if (this.nome !== '') {
          this.error.nome = false
        } else {
          this.error.nome = true
        }
      },
      deep: true
    }
  },

  created() {
    this.pageType()

    this.getHotels()
  },

  methods: {
    /** Verifica se é edição ou criação */
    pageType() {
      if (this.$route.name === 'AgrupadorHoteisCriar') {
        this.routeType = true
        this.pageTitle = 'Criar novo agrupador de hotéis'
        this.breadcrumb[2].label = 'Criar novo agrupador de hotéis'
      } else {
        this.routeType = false
        this.getSingleGroup()
      }
    },

    /** Retorna dados do agrupador */
    getSingleGroup() {
      this.$hotel.getHotelBundlers(this.$route.params.id).then((response) => {
        this.nome = response.data.nome

        response.data.hoteis.map((hotel) => {
          this.selectedItems.push({
            id: hotel.codigo,
            text: hotel.nome
          })
        })

        this.breadcrumb[2].label = `Editando ${this.nome}`
        this.pageTitle = `Editando ${this.nome}`
      })
    },

    /** Edição de agrupador de hotéis */
    edit() {
      if (this.nome === null || !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      const hotels = this.selectedItems.map((item) => {
        return parseInt(item.id)
      })

      this.loading = true

      this.$hotel
        .editHotelBundler({
          nome: this.nome,
          hoteis: hotels,
          codigo: parseInt(this.$route.params.id)
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de hotéis editado com sucesso'
          })

          this.$router.push({ name: 'AgrupadorHoteisListagem' })
        })
        .catch((err) => {
          if (
            err?.messages[0]?.includes(
              'Já existe um agrupador cadastrado com esse nome'
            )
          )
            return (this.showDuplicateAlert = true)

          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Cria um novo agrupador de hotéis */
    create() {
      if (this.nome === null || !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      const hotels = this.selectedItems.map((item) => {
        return parseInt(item.id)
      })

      this.loading = true

      this.$hotel
        .createHotelBundler({
          nome: this.nome,
          hoteis: hotels
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de hotéis criado com sucesso'
          })
          this.$router.push({ name: 'AgrupadorHoteisListagem' })
        })
        .catch((err) => {
          if (
            err.messages[0].includes(
              'Já existe um agrupador cadastrado com esse nome'
            )
          )
            return (this.showDuplicateAlert = true)

          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Chamada para deletar usuário */
    disable() {
      this.$hotel
        .disableHotelBundlers({ agrupadores: [parseInt(this.grouperId)] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de hotéis excluído com sucesso'
          })
          this.$router.push({ name: 'AgrupadorHoteisListagem' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de hotéis'
          })
        })
    },

    /** Retorna dados do usuário */
    getHotels() {
      this.$hotel.getShortenedHotelsList().then((response) => {
        const hotels = response.data.filter((hotel) => hotel.ativo)

        this.options = hotels.map((hotel) => {
          hotel.id = hotel.codigo
          hotel.value = hotel.codigo
          hotel.text = hotel.nome

          return hotel
        })
      })
    },

    /**
     * Controle de deleção
     * @param {String} grouperId: Id do agrupador
     */
    deleteModal(grouperId) {
      this.showDeleteModal = true
      this.grouperId = grouperId
    },

    /** Controle de cancelamento de deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.grouperId = null
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-title {
  margin-top: 40px;
  margin-left: 20px;
  margin-bottom: 15px;
}

.sidebar-buttons {
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
}

.horizontal-line {
  margin: 45px auto 45px;
}

.text-input {
  &--email {
    margin-top: 37px;
    margin-right: 35px;
    width: 270px;
  }
}

.form {
  display: block;
  gap: 20px;
  margin-bottom: 32px;
}

.select {
  width: 340px;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;

  &--return,
  &--save {
    width: 215px;
  }
}

::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}

::v-deep .content--white_card {
  padding: {
    top: 20px;
  }
}

.page-actions {
  padding-top: 50px;

  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }

  &--tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}
</style>

<style>
.alert-modal__duplicate-alert .alert-modal-content--icon__small {
  margin-bottom: 25px !important;
  height: 80px !important;
}
</style>
